import { motion } from 'framer-motion';
import { SectionHeader } from '../../../design-system/components';
import { cx } from '../../../design-system/components/cx';

/**
 * A section title split for SectionHeader: the last word is the orange
 * accent, the rest the plain part. The heading's text is unchanged (the
 * two parts render with one space between them), which the landing's
 * prerendered SEO output depends on (pages/landing/__tests__).
 */
function splitAccent(title: string): { title: string; accent?: string } {
  const cut = title.lastIndexOf(' ');
  if (cut <= 0) return { title };
  return { title: title.slice(0, cut), accent: title.slice(cut + 1) };
}

interface LandingHeaderProps {
  title: string;
  subtitle?: string;
  className?: string;
}

/** A landing section's h2 on SectionHeader, centred, the last word in orange. */
export function LandingHeader({ title, subtitle, className }: LandingHeaderProps) {
  return (
    <SectionHeader
      as="h2"
      size="section"
      {...splitAccent(title)}
      tagline={subtitle}
      className={cx('ee-landing-heading', className)}
    />
  );
}

/** LandingHeader that fades in as it scrolls into view. */
export default function SectionHeading({ title, subtitle, className }: LandingHeaderProps) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
    >
      <LandingHeader title={title} subtitle={subtitle} />
    </motion.div>
  );
}
